import React from "react"
import { Card, Grid } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as HomeIcon } from "uikit/Icons/homepurchase-goal.svg"
import { formatCurrency } from "uikit/utilities"

const HomePurchase = ({ id, year, amount, baseUrl, type }) => {
  return (
    <Card>
      <Card.Content>
        <Link
          to={`${baseUrl}/goals/${id}/${type.toLowerCase()}`}
          className="navlink"
        >
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column verticalAlign="middle" width={4}>
                <HomeIcon />
              </Grid.Column>
              <Grid.Column>
                <Grid>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <span className="GenericCard__LinkTitle">
                        Home Purchase
                      </span>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2} style={{ paddingTop: "0px" }}>
                    <Grid.Column verticalAlign="bottom">
                      <p
                        className="GoalCard_Price"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {formatCurrency(amount)}
                      </p>
                      <p className="greyed-text">price estimate</p>
                    </Grid.Column>
                    <Grid.Column className="GoalCard_Year_Div">
                      <p
                        className="GoalCard_SecondText"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {year}
                      </p>
                      <p className="greyed-text">year</p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Link>
      </Card.Content>
    </Card>
  )
}

export default HomePurchase
